// Whether a job has settled, the one place the web says so: every screen that waits for a job,
// offers an action only once it has ended, or stops reading it again asks here. A record over
// every status, so a status the API adds fails tsc until it is placed (pr-reviewer-2, #472).
import type { JobStatus } from "../../api/generated/model";

const SETTLED: Readonly<Record<JobStatus, boolean>> = {
  queued: false,
  submitting: false,
  running: false,
  finalizing: false,
  succeeded: true,
  failed: true,
  expired: true,
  canceled: true,
};

/** The job has ended (succeeded, failed, expired or canceled) and will not change again. */
export function isSettled(status: JobStatus): boolean {
  return SETTLED[status];
}
